import React from 'react';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';
import { PropTypes } from 'prop-types';
import IconDropzone from '../dropzone/icon-dropzone';
import ScreenshotDropzone from '../dropzone/screenshot-dropzone';
import RadioGroup from '../forms/radio-group';

@observer
export class NewAppScreenshots extends React.Component {

  static propTypes = {
    store: PropTypes.object.isRequired,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    disabled: false
  }

  constructor(props) {
    super(props);
    this.store = this.props.store;
    this.master = this.props.store.newAppMasterStore;
    this.references = {};

    reaction(() => this.master.newAppValidationsStore.errorDestination, () => {
      this.placeFocus()
    });
  }

  placeFocus = () => {
    this.master.newAppValidationsStore.placeFocus({
      references: this.references,
      defaultFieldId: this.store.screens.icon[0]
       ? 'device-type'
       : 'appIconBrowserButton'
    });
  }

  saveRef = (name, ref) => {
    this.references[name] = ref;
  }

  componentDidMount() {
    ['icon', 'mobile', 'tablet'].forEach(device => this.store.invalidUploadAttempted[device] = false);
    this.placeFocus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.disabled === true && this.props.disabled === false) {
      // The user has edited step 0 and resumed at this step
      this.placeFocus();
    }
  }

  renderSupportedDevicesRadio = () => {
    const optionsList = [
      {
        title: 'Mobile',
        hiddenValue: 'mobile'
      },
      {
        title: 'Tablet',
        hiddenValue: 'tablet'
      },
      {
        title: 'Mobile + Tablet',
        hiddenValue: 'mobileAndTablet'
      }
    ];
    return (
      <RadioGroup
        id="device-type"
        ref={(i) => this.references['deviceType'] = i}
        value={this.master.newAppData.device}
        updateValue={newValue => { this.store.changeDeviceType(newValue) }}
        required={true}
        labelText="Devices supported by this application"
        helperText="Must match supported devices in app package."
        optionsList={optionsList}
        errorMessage={this.master.REQUIRED_ERROR}
        disabled={this.props.disabled}
        showErrorDirectiveFromMaster={this.master.masterStateProps.errorsAreDisplayed} />
    )
  }

  render() {
    return (<div className="new-app-screenshots">
      <div className="container">
        <h2>Images</h2>
        <IconDropzone newAppMasterStore={this.master} disabled={this.props.disabled} saveRef={this.saveRef} />
        <hr />
        <div className="row screenshot-container">
          <div className="col-12">
            {this.renderSupportedDevicesRadio()}
          </div>
        </div>
        <ScreenshotDropzone newAppMasterStore={this.master} disabled={this.props.disabled} saveRef={this.saveRef} />
      </div>
    </div>);
  }
}
